import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { CheckboxField } from '..';

type CheckboxFieldProps = ComponentProps<typeof CheckboxField>;

type Props = {
  /** フォームフィールド名 */
  name: string;
  /** 選択肢の配列 */
  options: CheckboxFieldProps['options'];
  /** FieldWrapperのProps（htmlFor, errorMessages は自動で設定） */
  fieldWrapperProps: Omit<CheckboxFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
  /** 無効状態 */
  disabled?: boolean;
};

export const CheckboxFieldController: React.FC<Props> = ({
  name,
  options,
  fieldWrapperProps,
  disabled,
}) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <CheckboxField
      options={options}
      value={value ?? []}
      onChange={onChange}
      disabled={disabled}
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
    />
  );
};
